import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список записей блога
 */
export const selectBlogList = ({ blogList }: IApplicationState) => blogList;
